import React from 'react';
import Slider from './Slider.jsx';
import {Link} from "react-router-dom";

const CategoryItems = (props) =>
	<Link to={`${props.match.match.path}/`+props.product.name} className='category-item'>
		<Slider img={props.product.img}
			showAnime={props.n<4?true:false}
			product={props.product} arrow={false}/>
	</Link>

export default CategoryItems;